

export const username_regex=/^[a-z0-9]{2,16}$/;
export const docid_regex=/^([a-z0-9]{2,16})\/([a-zA-Z0-9/-]{2,64})$/;

export type PropertyObject = { [key: string]: string | number | any[] | Record<string, any> | Uint8Array } & { id?: string };
export type PropertyObjectWithId = PropertyObject & { id: string };
export type TypedPropertyObject = PropertyObject & {
    /** item id, unique per document */
    id: string,
    
    x: number, y: number, width: number, height: number,

    /** object creation timestamp */
    ct?: number,
    /** server-side object last-modified timestamp */
    mt?: number, 
    /** client-side object last-modified timestamp (only set on unsynced items) */
    lmt?: number,
    /** fill timestamp () */
    ft?: number,
    /** timestamp when a checkbox item was set to "in progress" (🔜, ➡️) */
    startTs?: number,
    /** timestamp when a checkbox item was set to "done" (✅, ☑️) */
    doneTs?: number,

    text?: string, textMode?: string, icon?: string, iconSize?: number,
    border?: string,
    backgroundSize?: string,
    backgroundRepeat?: string,
    image?: string,
    backgroundColor?: string,
    textColor?: string,
    textSize?: number | string,
    font?: string,
    zIndex?: number | string,
    padding?: number | string,
    class?: string,
    nosel?: string | number,
    nomove?: string | number,
    autosize?: string | number,
};

export type PointType = { x : number , y : number };
export class Point {
    static readonly zero = new Point(0, 0);
    constructor(public readonly x : number, public readonly y : number) {
    }
    plus(other: PointType): Point {
        return new Point(this.x + other.x, this.y + other.y);
    }
    minus(other: PointType | PropertyObject | Readonly<PropertyObject>): Point {
        return new Point(this.x - +other.x, this.y - +other.y);
    }
    negate(): Point {
        return new Point(-this.x, -this.y);
    }
    static min(...points: (PointType | PropertyObject | Readonly<PropertyObject>)[]): Point {
        return new Point(...<[number,number]>points.reduce(([x,y], item) => [Math.min(x,+item.x), Math.min(y,+item.y)], [999999,999999]));
    }
}